import React, { useEffect, useState } from "react";
import { SuccessBurst } from "@/components/SuccessBurst";

/** Fenêtre de célébration globale : `window.dispatchEvent(new CustomEvent("bevid:celebrate", { detail: { title, subtitle } }))`. */
export function celebrate(title, subtitle) {
  window.dispatchEvent(new CustomEvent("bevid:celebrate", { detail: { title, subtitle } }));
}

export function CelebrationHost() {
  const [ev, setEv] = useState(null);
  useEffect(() => {
    const on = (e) => setEv(e.detail || {});
    window.addEventListener("bevid:celebrate", on);
    return () => window.removeEventListener("bevid:celebrate", on);
  }, []);
  return <SuccessBurst show={!!ev} title={ev?.title} subtitle={ev?.subtitle} onDone={() => setEv(null)} duration={1500} />;
}
